import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './Navbar/Navbar';
import Footer from './Footer/footer';
import AppRouter from './router/index';

const App = () => (
  <Router>
    <Navbar />
    <AppRouter />
    <Footer />
  </Router>
);

export default App;
